import React, { Component, useEffect } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Redirect,
  useLocation
} from 'react-router-dom';
import 'intersection-observer'; // polyfill

import yoda from '@ks/yoda-js-sdk';
import { Provider } from 'react-redux';
import GlobalLoading from '@/components/GlobalLoading';
import UserInfo from '@components/UserInfo';
import Error from '@components/Error';
import { getCookie } from '@utils/cookies';
import weblog from '@aio/weblog';
import Sentry from './utils/sentry-mock';
import { store } from './store';
import pureStore from './pure-store';
import { renderRouter, mainRouters } from './routers';
import pvRoutes from './configs/pv-routes';
import radar from './utils/useRadar';
import './services/apiSig';

import './styles/global.scss';
import './styles/common.scss';

const weblogOption = {
  // 页面曝光
  routes: pvRoutes,
  env: process.env.NX_APP_ENV !== 'prod' ? 'logger' : 'production',
  yoda,
  plugins: [radar]
};

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
weblog.init(weblogOption, {
  product_name:
    window.location.pathname === '/' ? 'KUAISHOU' : 'KUAISHOU.healthy',
  sub_biz: 'Channel_Healthy',
  user_id: getCookie('ud')
});

weblog.doWeblogCollect(); // 页面初始化，手动上报pv

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

class App extends Component {
  componentDidMount() {
    if (yoda.isInYoda) {
      // 设置电池栏图标文字颜色
      yoda.ready().then(() => {
        if (yoda && yoda.webview && yoda.webview.hideNavigationBar)
          yoda.webview.hideNavigationBar();
      });
    }
  }

  render() {
    return (
      <>
        <Provider store={store}>
          <Router>
            <ScrollToTop />
            <Switch>
              {renderRouter(mainRouters)}
              <Redirect to="/" />
            </Switch>
            <UserInfo />
          </Router>
        </Provider>
        <Provider store={pureStore}>
          <GlobalLoading />
        </Provider>
      </>
    );
  }
}

export default Sentry.withErrorBoundary(App, {
  fallback: <Error />
});
